module.exports = __webpack_public_path__ + "img/github.8a75cd1f.svg";